import ProductCard from '@components/Cards/ProductCard';
import GeneralCarousel from '@components/carousels/GeneralCarousel';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import React from 'react';
import useBasket from '@hooks/basket/useBasket';

const CartRecommendations = () => {
  const { t } = useTranslation();
  const { data } = useBasket();
  const { recommendations = [] } = data || {};

  if (!recommendations?.length) {
    return null;
  }
  return (
    <div className="tw-bg-warm-200 tw-py-14 tw-px-6 md:tw-max-w-xs sm:tw-py-10 sm:tw-px-10 md:tw-grid-in-a tw-z-0">
      <h5 className="tra-text-web-heading-5 sm:tra-text-web-heading-7 tw-mb-4 tw-text-left">
        {t('cart.recommendationsTitle', undefined, { default: 'Recommended Products' })}
      </h5>
      <hr className="tw-bg-brand-300 tw-h-1 tw-mb-6 tw-w-10" />
      <ul className="tw-hidden sm:tw-grid tw-content-start tw-gap-y-4 tw-list-none tw-p-0">
        {recommendations.slice(0, 3).map((product) => (
          <li key={product.sku}>
            <ProductCard product={product} small />
          </li>
        ))}
      </ul>
      {recommendations && (
        <div className="sm:tw-hidden">
          <GeneralCarousel _data={recommendations} smallCards />
        </div>
      )}
    </div>
  );
};

export default CartRecommendations;
